import { render, staticRenderFns } from "./edit-textarea-dialog.vue?vue&type=template&id=21d2b8fe&scoped=true&"
import script from "./edit-textarea-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-textarea-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2b8fe",
  null
  
)

export default component.exports